import React, { Fragment } from 'react';
import { number } from 'prop-types';
import { calculateStarType } from 'components/Star/utils';
import { Star } from 'components';

export default function ProductCardRatings({ ratingCount, ratingStars }) {
    return (
        <span className="product-card-ratings">
            {ratingCount > 0 && (
                <Fragment>
                    {[...Array(5).keys()].map(index => (
                        <Star
                            key={index}
                            starType={calculateStarType(ratingStars, index)}
                        />
                    ))}

                    <span className="ratings-stars__item product-card-ratings__count">
                        {`(${ratingCount})`}
                    </span>
                </Fragment>
            )}
        </span>
    );
}

ProductCardRatings.propTypes = {
    ratingCount: number,
    ratingStars: number,
};

ProductCardRatings.defaultProps = {
    ratingCount: 0,
    ratingStars: 0,
};
